import { useVisibilityState } from '@lbcamden/lib-react';
import { useCallback, useState } from 'react';

import { PcfraPerson } from '~/common/types/people';

import { RevokePcfraDialog } from './RevokePcfraDialog';

export const useRevokePcfraDialog = () => {
  const [person, setPerson] = useState<PcfraPerson>();

  const { show, hide, visible } = useVisibilityState();

  const showRevokePcfraDialog = useCallback((selectedPerson: PcfraPerson) => {
    setPerson(selectedPerson);
    show();
  }, []);

  return {
    showRevokePcfraDialog,
    revokePcfraDialog: <RevokePcfraDialog open={visible} person={person} onClose={hide} />,
  };
};
